export default __webpack_public_path__ + "media/images/brands/oka-687e5bc5b6f86af6505e96ea56886dcd.png";